import React, { createContext, useContext, ReactNode } from 'react'

interface LocationContextType {
  locationId?: string
  locationName?: string
  setLocationData: (id: string, name: string) => void
}

const LocationContext = createContext<LocationContextType | undefined>(undefined)

export function LocationProvider({ children }: { children: ReactNode }) {
  const [locationId, setLocationId] = React.useState<string>()
  const [locationName, setLocationName] = React.useState<string>()

  const setLocationData = (id: string, name: string) => {
    setLocationId(id)
    setLocationName(name)
  }

  return (
    <LocationContext.Provider
      value={{
        locationId,
        locationName,
        setLocationData,
      }}
    >
      {children}
    </LocationContext.Provider>
  )
}

export function useLocationContext() {
  const context = useContext(LocationContext)
  if (context === undefined) {
    throw new Error('useLocationContext must be used within a LocationProvider')
  }
  return context
} 